import React from 'react';

import CreatableSelect from 'react-select/creatable';

/** components */
import LabelWithTooltip from './LabelWithTooltip';

/** helpers */
import { validateInputField } from '../../helpers/validation';
import { useForm } from '../../hooks/useForm';

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    color: state.isSelected ? '#fff' : '#727272',
    fontFamily: "'Lato', sans-serif !important",
    fontWeight: 300,
    fontSize: 27,
    padding: '10px 25px',
  }),
  input: (styles, { data }) => ({
    ...styles,
    color: '#727272',
    fontSize: '27px',
    cursor: 'pointer',
    padding: '10px 25px',
    margin: '0',
  }),
  singleValue: (styles, { data }) => ({
    ...styles,
    color: '#727272',
    fontSize: '27px',
    cursor: 'pointer',
    padding: '10px 25px',
  }),
  placeholder: (styles, { data }) => ({
    ...styles,
    color: '#727272',
    fontSize: '27px',
    cursor: 'pointer',
    padding: '10px 25px',
  }),
  indicatorSeparator: (styles, { data }) => ({
    ...styles,
    display: 'none',
  }),
};

const SelectOneWithFreeInput = ({
  data,
  setData,
  dataError,
  setDataError,
  field,
  toggleFieldModal,
  isModalOpen,
  initializeSectionError,
  maskInputEl,
  feature,
  fieldClassName,
}) => {
  const { getPropertyFields } = useForm();
  const filteredOptions = field.options.filter((option) => {
    if (field.linked) return option.displayForValue === data[field.linked];
    return true;
  });
  if (filteredOptions.length === 0 && data[field.name] !== '') {
    setData({ ...data, [field.name]: '' });
  }
  const handleChange = (e, name, field) => {
    initializeSectionError();
    validateInputField(e.value, name, field, setDataError);

    let updateValues = { [name]: e.value };
    let updatedValues = getPropertyFields(feature, data, updateValues, field?.name, true);

    let values = updatedValues.isUpdatedValue ? updatedValues.newValues : updateValues;

    setData({ ...data, ...values });
    maskInputEl?.current?.setInputValue('');
  };

  return (
    <div key={field.name} className={fieldClassName}>
      <div className="form-field">
        <LabelWithTooltip
          field={field}
          toggleFieldModal={toggleFieldModal}
          isModalOpen={isModalOpen}
        />
        <CreatableSelect
          placeholder="Select an option"
          name={field.name}
          options={filteredOptions}
          styles={customStyles}
          onChange={(e) => handleChange(e, field.name, field)}
          getOptionLabel={(option) => option.label}
          getOptionValue={(option) => option.value}
          formatCreateLabel={(v) => v}
          closeMenuOnSelect
          backspaceRemovesValue
          defaultInputValue={data[field.name]}
        />
      </div>
      {dataError[field.name] && <p className="error-text">{dataError[field.name]}</p>}
    </div>
  );
};

export default SelectOneWithFreeInput;
